import React from 'react';

interface SwitchProps {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	disabled?: boolean;
	className?: string;
}

export const SwitchToggle = React.forwardRef<HTMLButtonElement, SwitchProps>(
	function SwitchToggle(
		{ checked, onCheckedChange, disabled = false, className = '' },
		ref
	) {
		return (
			<button
				type="button"
				role="switch"
				aria-checked={checked}
				disabled={disabled}
				ref={ref}
				onClick={() => onCheckedChange(!checked)}
				className={`
          relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent 
          transition-colors duration-200 ease-in-out focus:outline-none focus:ring-1 focus:ring-gray-300 
          focus:ring-offset-2 ${checked ? 'bg-[#324B69]' : 'bg-gray-200'} 
          ${disabled ? 'cursor-not-allowed opacity-50' : ''} 
          ${className}
        `}
			>
				<span className="sr-only">{checked ? 'On' : 'Off'}</span>
				<span
					aria-hidden="true"
					className={`
            pointer-events-none inline-block h-4 w-4 transform rounded-full 
            bg-white shadow ring-0 transition duration-200 ease-in-out
            ${checked ? 'translate-x-5' : 'translate-x-0'}
          `}
				/>
			</button>
		);
	}
);
